import { NgModule }                       from '@angular/core';
import {  RouterModule }   from '@angular/router';

import { PageNotFoundComponent }          from './not-found.component';
import { AuthGuardService }               from 'app/core/security/route-guards.service';
//import { ProfileComponent } from 'app/core/profile/profile.component';
import { CoreModule } from 'app/core/core.module';
import { ProfileComponent } from 'app/core/profile/profile.component';



const appRoutes = [

    //{ path: 'admin/pj/duplicates',  loadChildren: './pages/admin/pjDuplicates/pjDuplicates.module#PJDuplicatesModule',    canActivate: [AuthGuardService]  },
    { path: 'admin/pj',  loadChildren: './pages/admin/pj/pj.module#PJModule',    canActivate: [AuthGuardService]  },
    { path: 'admin/notes',  loadChildren: './pages/admin/notes/notes.module#NotesModule',    canActivate: [AuthGuardService]  },
    { path: 'profile',  component: ProfileComponent,    canActivate: [AuthGuardService]  },
    { path: 'home',     loadChildren: './pages/home/home.module#HomeModule' },
    { path: 'cartes',   loadChildren: './pages/cartes/cartes.module#CartesModule' },
    { path: 'aide',     loadChildren: './pages/aide/aide.module#AideModule' },
    { path: 'map',      loadChildren: './pages/map/map.module#MapModule' },
    { path: 'nuages',   loadChildren: './pages/nuages/nuages.module#NuagesModule' },
    { path: 'outils',   loadChildren: './pages/outils/outils.module#OutilsModule' },


//{ path: 'home',     component: AppHomeComponent },

    { path: '', redirectTo: '/home', pathMatch: 'full' },
    { path: '**',       component: PageNotFoundComponent }
  ];

@NgModule({
  imports: [
    CoreModule,
    RouterModule.forRoot(
      appRoutes,
      { enableTracing: false, useHash:true } // <-- debugging purposes only
    )
  ],
  exports: [
    RouterModule
  ],
  providers: [
    AuthGuardService
  ]
})
export class AppRoutingModule {

    /*constructor(router: Router) {
        console.log('Routes: ', JSON.stringify(router.config, undefined, 2));
      }*/

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/randonneurs-2018-build-and-to-local/src/app/app-routing.module.ts